import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Input } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const BalanceReminderSettings = () => {
  const { t } = usePrefs();
  const [v, setV] = useState({ IQD: "", USD: "" });
  useEffect(() => { api.get("/admin/balance-reminder").then((r) => setV({ IQD: r.data.IQD || "", USD: r.data.USD || "" })).catch(() => {}); }, []);
  const save = async () => {
    try {
      const { data } = await api.put("/admin/balance-reminder", v);
      setV({ IQD: data.IQD || "", USD: data.USD || "" });
      toast.success(t("b8.reminderSaved"));
    } catch (e) {
      toast.error(errorText(e, t));
    }
  };
  return (
    <div data-testid="balance-reminder-card" className="rounded-3xl border bg-card p-5 space-y-3">
      <p className="font-bold flex items-center gap-2"><BellRing className="h-5 w-5 text-primary" />{t("b8.reminderTitle")}</p>
      <p className="text-sm text-muted-foreground">{t("b8.reminderNote")}</p>
      <div className="flex flex-wrap items-end gap-2">
        {(["IQD", "USD"] as const).map((c) => (
          <label key={c} className="text-xs font-bold space-y-1">{c}
            <Input dir="ltr" inputMode="decimal" value={v[c]} onChange={(e: any) => setV({ ...v, [c]: e.target.value })} placeholder={t("b8.off")} data-testid={`balance-reminder-${c}`} className="h-10 rounded-full w-36" />
          </label>
        ))}
        <button onClick={save} data-testid="balance-reminder-save" className="h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold">{t("common.save")}</button>
      </div>
    </div>
  );
};
